// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".history-form-dialog-comment[data-v-697d83ab]{flex-basis:500px}", ""]);
// Exports
module.exports = exports;
